/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var allPlus = document.querySelectorAll('.quant-plus')
var allMinus = document.querySelectorAll('.quant-minus')
var allQuants = document.querySelectorAll('.quant-input')
allPlus.forEach(plus => {
  plus.addEventListener('click', function(e) {
    e.preventDefault()
    e.target.previousElementSibling.value = parseInt(e.target.previousElementSibling.value) + 1;
  })
})

allMinus.forEach(minus => {
  minus.addEventListener('click', function(e) {
    e.preventDefault()
	e.target.nextElementSibling.value = Math.max(parseInt(e.target.nextElementSibling.value) - 1, 1);  })
})

allQuants.forEach(quant => {
  quant.addEventListener('change', function(e) {
    e.target.value = Math.max(parseInt(e.target.value) || 1, 1);
  })
})
